import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const Interier = {
	name: NAME,
	apiProvider,
	router,
};
